// custom-quicklink.strategy.ts
import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { QuicklinkStrategy } from 'ngx-quicklink';
import { PreloadingManagerService } from './preloading-manager.service';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CustomQuicklinkStrategy implements PreloadingStrategy {
    constructor(
        private preloadingManager: PreloadingManagerService,
        private quicklink: QuicklinkStrategy
    ) { }

    preload(route: Route, load: () => Observable<any>): Observable<any> {
        return this.preloadingManager.preloadingEnabled$.pipe(
            switchMap(enabled => {
                if (enabled) {
                    // If preloading is enabled, we delegate the work to the original strategy.
                    return this.quicklink.preload(route, load);
                }
                // If disabled, we do nothing and return an observable of null.
                return of(null);
            })
        );
    }
}